import angular from 'angular';
import uiRouter from 'angular-ui-router';
import myLoansCardComponent from './myLoansCard.component';

let myLoansCardModule = angular.module('myLoansCard', [
  uiRouter
])

.component('myLoansCard', myLoansCardComponent)

.name;

export default myLoansCardModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/myLoansCard/myLoansCard.js